import { render, staticRenderFns } from "./account-main.vue?vue&type=template&id=dac88284&scoped=true&"
import script from "./account-main.vue?vue&type=script&lang=js&"
export * from "./account-main.vue?vue&type=script&lang=js&"
import style0 from "./account-main.vue?vue&type=style&index=0&id=dac88284&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac88284",
  null
  
)

export default component.exports